import React, { useEffect, useState } from "react";
import IntentType from "../../../../intentexecutor/utils/IntentType";
import { performPostRequest } from "../../../../service/network/NetworkService";
import { getApiUrl } from "../../../../service/network/UrlMapper";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";
import Task from "./Task";

const templateCodeCache = new Map();

const AddEditTask = ({ careplan, opportunity }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [templateCodes, setTemplateCodes] = useState([]);

  useEffect(() => {
    const getTemplateCodes = async () => {
      const parsedServices =
        careplan?.services && JSON.parse(careplan?.services);

      // case: directly has templateCode in services
      if (parsedServices[0]?.templateCode) {
        setTemplateCodes([parsedServices[0]?.templateCode]);
        return;
      }

      // otherwise -> extract serviceKeys
      const services = parsedServices?.map((service) => JSON.parse(service));
      const serviceKeys = services?.map((service) => service?.serviceKey);

      // check cache
      const cachedResults = serviceKeys.map((key) =>
        templateCodeCache.get(key)
      );
      const missingKeys = serviceKeys.filter(
        (key, idx) => !cachedResults[idx] // those not in cache
      );

      // fetch missing ones if any
      if (missingKeys.length > 0) {
        const payload = {
          intent: IntentType.GET_CONFIGURATION,
          payload: { configurationKey: missingKeys },
          context: { organizationIdentifier },
        };

        const response = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(payload)
        );
        const result = await response.json();

        if (Array.isArray(result)) {
          result.forEach((key) => {
            const config =
              key?.configurationValue && JSON.parse(key?.configurationValue);
            const tCode = config?.templateCode || config?.templatecode;
            if (tCode) {
              templateCodeCache.set(key?.configurationKey, tCode);
            }
          });
        }
      }

      // build final templateCodes from cache
      const finalCodes = serviceKeys
        .map((key) => templateCodeCache.get(key))
        .filter(Boolean);

      setTemplateCodes([...new Set(finalCodes)]);
    };

    if (careplan?.services) {
      getTemplateCodes();
    }
  }, [careplan?.services, organizationIdentifier]);

  return (
    <>
      <Task
        templateCodes={templateCodes}
        opportunity={opportunity}
        patientIdentifier={careplan?.patientIdentifier}
        carePlanId={careplan?.id}
      />
    </>
  );
};

export default AddEditTask;
